import React, { useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { BookmarkPlus, FileText, Megaphone } from 'lucide-react';
import { API, FIELDS, OPT_OUT_LINE, errMsg, isGsm, segments } from './api';

export const MessageStep = ({ body, setBody, marketing, setMarketing, templates, headers, onTemplatesChanged }) => {
  const ref = useRef(null);
  const [saving, setSaving] = useState(false);
  const [tplName, setTplName] = useState('');
  const insert = (f) => {
    const el = ref.current; const s = el?.selectionStart ?? body.length; const e = el?.selectionEnd ?? body.length;
    const next = body.slice(0, s) + f + body.slice(e); setBody(next);
    requestAnimationFrame(() => { el?.focus(); el?.setSelectionRange(s + f.length, s + f.length); });
  };
  const full = marketing && !body.toLowerCase().includes('stop') ? `${body.trimEnd()}\n${OPT_OUT_LINE}` : body;
  const parts = segments(full);
  const save = async () => {
    try { await axios.post(`${API}/templates`, { name: tplName, body }, headers); toast.success('Template saved'); setSaving(false); setTplName(''); onTemplatesChanged(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="bsx-step" data-testid="bsx-step-message">
      {templates.length > 0 && (
        <div className="bsx-tpls" data-testid="bsx-templates">
          <span className="bsx-lbl"><FileText size={13} />Templates</span>
          {templates.map((t) => <button type="button" key={t.id} onClick={() => setBody(t.body)} className="bsx-tpl" data-testid={`bsx-template-${t.id}`} title={t.body}>{t.name}</button>)}
        </div>
      )}
      <div className="bsx-editor">
        <textarea ref={ref} value={body} onChange={(e) => setBody(e.target.value)} rows={7} maxLength={1500} placeholder="Hi {{FIRST_NAME}}, ..." data-testid="bsx-message" />
        <div className="bsx-editor-bar">
          <div className="bsx-fields">{FIELDS.map((f) => <button type="button" key={f} onClick={() => insert(f)} data-testid={`bsx-field-${f.replace(/[{}]/g, '').toLowerCase()}`}>{f.replace(/[{}]/g, '').replace('_', ' ').toLowerCase()}</button>)}</div>
          <span className={`bsx-count${parts > 2 ? ' warn' : ''}`} data-testid="bsx-char-count">{full.length} chars · {parts} SMS{!isGsm(full) && ' · emoji/unicode'}</span>
        </div>
      </div>
      <label className="bsx-switch" data-testid="bsx-marketing" onClick={(e) => { e.preventDefault(); setMarketing(!marketing); }}>
        <span role="switch" aria-checked={marketing} tabIndex={0} onKeyDown={(e) => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); setMarketing(!marketing); } }} className={`track${marketing ? ' on' : ''}`} data-testid="bsx-marketing-switch"><span /></span>
        <span><b><Megaphone size={13} />Marketing message</b><small>Adds “{OPT_OUT_LINE}” as Australian spam law requires. Turn off only for service messages about an existing loan.</small></span>
      </label>
      {saving
        ? <form className="bsx-save" onSubmit={(e) => { e.preventDefault(); if (tplName.trim() && body.trim()) save(); }}><input autoFocus value={tplName} onChange={(e) => setTplName(e.target.value)} placeholder="Template name" data-testid="bsx-template-name" /><button type="submit" className="btn btn-solid btn-sm" data-testid="bsx-template-save">Save</button><button type="button" className="btn btn-ghost btn-sm" onClick={() => setSaving(false)}>Cancel</button></form>
        : <button type="button" className="bsx-link" disabled={!body.trim()} onClick={() => setSaving(true)} data-testid="bsx-template-new"><BookmarkPlus size={14} />Save as template</button>}
    </div>
  );
};
